var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.loading)?_c('div',{staticClass:"app-loading mx-auto mt-3 mb-3"},[_c('div',{staticClass:"app-loading__image-wrapper",class:[_vm.isBackground && 'app-loading__image-wrapper--background']},[_c('img',{staticClass:"app-loading__image",attrs:{"src":_setup.themeImage('logo-small.svg'),"alt":"Loading"}})])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }